/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useData1 } from "../data/useData1";
import { useChart1 } from "../transformers/useChart1";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { useExport, useSubscriptionProviderContext } from "../../../shared";

export const ComponentChart1: React.FC<{ context: ContextReport1 }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const payload = useHookSubscribe(null, context.payloadChart1);
  const data = useData1(payload);
  const chartData = useChart1(data);
  const source = useHookSubscribe(null, context.sources$);

  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);

  if (window["exportMode"]) {
    window["exportReady"] = chartData && context.readyState !== ComponentContextReadyState.Loading;
  }

  if (!window["exportMode"] && (!chartData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>Area, production, yield</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} loader={<ComponentPreloader />} />
    </>
  );
};
